const codeRelationships = Object.freeze({
  Mother: 2075,
  Father: 2076,
  Attendant: 2077,
  Other: 2081,
  Teacher: 703,
  Director: 236,
});

const codeRelationshipString = {
  [codeRelationships.Mother]: 'Madre',
  [codeRelationships.Father]: 'Padre',
  [codeRelationships.Attendant]: 'Encargado',
  [codeRelationships.Other]: 'Otro',
  [codeRelationships.Teacher]: 'Maestro',
  [codeRelationships.Director]: 'Director',
};

const getcodeRelationshipNameByCode = (code) => {
  return codeRelationshipString[code];
};

export {
  codeRelationships,
  codeRelationshipString,
  getcodeRelationshipNameByCode,
};
